'use strict';

var toastModule = require('bootstrap/js/src/toast.js');
var Toast = toastModule.default || toastModule;

/**
 * Post-registration confirmation toast.
 *
 * accountHelpers.js appends registration=submitted to the redirect it builds, but also
 * registration=false after a plain login: hence the strict comparison. Bootstrap owns the hiding,
 * its defaults already autohide after 5000ms.
 */

// Read on arrival, then stripped from the address bar: both must name the same parameter.
var TRIGGER_PARAM = 'registration';

/**
 * Rebuilds a query string without one parameter, keeping the args the redirect may also carry.
 * @param {string} search - location.search, with or without its leading question mark.
 * @param {string} name - the parameter to drop.
 * @returns {string} the remaining query string prefixed with a question mark, or an empty string.
 */
function removeQueryParam(search, name) {
    var params = new URLSearchParams(search);

    params.delete(name);

    var query = params.toString();

    return query ? '?' + query : '';
}

/**
 * Fills the live region with the toast box, using only methods cheerio also carries so the unit
 * tests can exercise it without a DOM.
 * @param {Object} $host - the live region rendered by common/layout/page.isml.
 * @param {string} message - the already localised confirmation message.
 * @returns {Object} the freshly appended box.
 */
function renderToast($host, message) {
    // No ARIA role on the box: the wrapper it lands in is already the live region.
    $host.append('<div class="toast hf-toast__box">'
        + '<div class="toast-body hf-toast__body">'
        + '<span class="icon icon-double-checkmark" aria-hidden="true"></span>'
        + '<span class="hf-toast__message"></span>'
        + '</div>'
        + '</div>');
    $host.find('.hf-toast__message').text(message);

    return $host.find('.hf-toast__box');
}

/**
 * Drops the trigger parameter from the address bar so a refresh does not replay the toast.
 */
function cleanUrl() {
    window.history.replaceState(
        null,
        '',
        window.location.pathname
            + removeQueryParam(window.location.search, TRIGGER_PARAM)
            + window.location.hash
    );
}

module.exports = {
    showRegistrationSuccess: function () {
        if (new URLSearchParams(window.location.search).get(TRIGGER_PARAM) !== 'submitted') {
            return;
        }

        // One-shot signal: consume it even on pages that carry no live region.
        cleanUrl();

        var $host = $('.js-toast');
        // Undefined on the pages that do not render the wrapper, empty selection included.
        var message = $host.data('registration-message');

        if (!message) {
            return;
        }

        var $box = renderToast($host, message);

        // Bootstrap only hides the node; drop it so the region can announce a later insertion.
        $box.on('hidden.bs.toast', function () {
            $box.remove();
        });

        Toast.getOrCreateInstance($box[0]).show();
    },

    // processInclude (js/util.js) calls every exported function, so renderToast cannot sit here.
    helpers: {
        removeQueryParam: removeQueryParam,
        renderToast: renderToast
    }
};
